export default function HowItWorks() {
  const steps = [
    {
      step: '01',
      title: 'Wybierz kategorię',
      desc: 'Przejdź na stronę główną i wybierz interesującą Cię kategorię z 14 dostępnych grup produktowych – od butów po akcesoria.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20colorful%20category%20grid%20interface%20with%20icons%20on%20screen%2C%20held%20in%20hand%20against%20warm%20cream%20background%2C%20soft%20natural%20window%20light%2C%20clean%20minimalist%20aesthetic%2C%20app%20browsing%20concept%2C%20warm%20neutral%20tones%2C%20editorial%20product%20photography%20with%20hands%2C%20focused%20and%20intentional%20composition&width=600&height=400&seq=how-step-01&orientation=landscape',
    },
    {
      step: '02',
      title: 'Znajdź produkt',
      desc: 'Kliknij w wybraną kategorię, aby przejść do pełnej listy starannie wyselekcjonowanych produktów na Kakobuy Spreadsheet.',
      image: 'https://readdy.ai/api/search-image?query=Laptop%20screen%20displaying%20organized%20product%20list%20grid%20with%20images%20and%20prices%2C%20clean%20desk%20workspace%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%20from%20window%2C%20modern%20ecommerce%20browsing%20scene%2C%20focused%20on%20screen%20content%2C%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20product%20discovery%20theme&width=600&height=400&seq=how-step-02&orientation=landscape',
    },
    {
      step: '03',
      title: 'Kup przez Kakobuy',
      desc: 'Wybierz produkt, przejdź do platformy Kakobuy jednym kliknięciem i sfinalizuj bezpieczny zakup z dostawą do Polski.',
      image: 'https://readdy.ai/api/search-image?query=Happy%20customer%20completing%20online%20purchase%20on%20laptop%20with%20shopping%20cart%20confirmation%20screen%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20satisfaction%20and%20completion%20theme%2C%20modern%20ecommerce%20checkout%20concept%2C%20clean%20desk%20with%20coffee%20cup%2C%20warm%20neutral%20tones%2C%20editorial%20lifestyle%20photography%20with%20positive%20energy&width=600&height=400&seq=how-step-03&orientation=landscape',
    },
  ];

  return (
    <section id="jak-dziala" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Jak działa Kakobuy Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            Trzy proste kroki, które pozwolą Ci szybko znaleźć i zamówić najlepsze produkty z Chin.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {steps.map((item, idx) => (
            <div
              key={item.step}
              className="group relative flex flex-col rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300"
            >
              {/* Step Image */}
              <div className="relative h-44 md:h-52 overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={`Krok ${item.step}: ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={`Kakobuy Spreadsheet – krok ${item.step}`}
                />
                <div className="absolute top-3 left-3 w-9 h-9 rounded-xl bg-primary-500 flex items-center justify-center">
                  <span className="font-heading text-background-50 font-bold text-xs">{item.step}</span>
                </div>
              </div>

              {/* Step Content */}
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
                  {item.desc}
                </p>
                {/* Connector arrows between steps (desktop only) */}
                {idx < 2 && (
                  <div className="hidden md:block absolute -right-4 top-1/2 -translate-y-1/2 z-10">
                    <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100">
                      <i className="ri-arrow-right-line text-primary-500 text-sm"></i>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}